const majorTag = 'sec'
const settings = {
  //项目名称
  title: '证券从业模拟考试系统',
  //机考辅导类型
  category: '证券从业',
  //机考辅导ID
  majorID: 8,
  // 辅导唯一标识
  majorTag: majorTag,
  //生产环境二级路径
  publicPath: '/qzSim/' + majorTag + '/',
  //生产环境构建文件目录
  outputDir: 'webApp',
  //静态资源放置目录
  assetsDir: 'static',
  //aes密钥
  aesKey: '823s4125660ijf;*',
  //iv密钥
  ivKey: 'qyu148#4(1p_1^4;',
  //请求接口地址
  baseApi: '/simPaperGw/moniexam',
  //请求重试delay
  retryDelay: 5000
}

module.exports = settings
